module.exports = __webpack_public_path__ + "static/img/cbuenosaires.00cba7f4.svg";